import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ClientTabs, TabItem } from "./ClientTabs";
import { Modal } from "./Modal";
import { ClientContractRow, ClientContract } from "./ClientContractRow";
import { ClientInfoCard } from "./ClientInfoCard";
import logotoulouse from "../assets/img/img/logotoulouse.png";
import logobrive from "../assets/img/img/logobrive.png";
import myImage from "../assets/img/img/logopdf.png";
import gmail from "../assets/img/img/gmail.png";
import phone from "../assets/img/img/phone.png";
import { Modal as AntdModal } from "antd";
import cgpasnieres from "../assets/img/img/cgpasnieres.png";
import cgpbrive from "../assets/img/img/cgpbrive.png";
import cgptoulouse from "../assets/img/img/cgptoulouse.png";
import propositionJminterim from "../assets/img/img/proposition-jminterim.jpg";
import propositionCapeneo from "../assets/img/img/proposition-capaneo.jpg";

import { InfoItem } from "./InfoItem";
import { Button } from "../ui/Button";
import jsPDF from "jspdf";

import qualifications from "../utils/qualifications";
import MultiSelect from "../ui/MultiSelect";
import { ContactCard, Contact } from "./ContactCard";
import { ContactFormModal } from "./ContactFormModal";
import { FileCard, File } from "./FileCard";
import { FileRow } from "./FileRow";
import FileUploadModal from "./FileUploadModal";
import { InvoiceCard, Invoice } from "./InvoiceCard";
import ScheduleEntryCard from "./ScheduleEntry";
import { NoteCard, Note } from "./NoteCard";
import { NoteFormModal } from "./NoteFormModal";
import { EventCard, Event } from "./EventCard";
import { EventRow } from "./EventRow";
import { QuoteCard, Quote } from "./QuoteCard";
import { AtradiusCard, AtradiusRequest } from "./AtradiusCard";
import { CommentCard, Comment } from "./CommentCard";
import { CommentFormModal } from "./CommentFormModal";
import { getTabIcon } from "./tabIcons";
import { RatingCard, Rating } from "./RatingCard";
import axios from "../axios/AxiosInstance";
import { Alert, message } from "antd";
import { formatDate, formatJsDate } from "../utils/formatageDate";
import { Input } from "../ui/Input";
import { Label } from "../ui/Label";

import { Textarea } from "../ui/TextArea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/Select";
import { Tabs, TabsList, TabsTrigger } from "../ui/Tabs";
import {
  Loader2,
  Search,
  UserCog,
  PhoneIcon,
  MailIcon,
  MapPinIcon,
} from "lucide-react";
import CreateClientModal from "./clients/CreateClientModal";
import QuotationForm from "./devis/QuotationForm";
import QuotationModal from "./devis/QuotationModal";
import ContractModal from "./contract/ContractModal";

const mockContracts = [
  {
    id: "1",
    contractNumber: "2023-0001",
    company: {
      name: "J'M INTERIM",
      agencyNumber: "15872",
    },
    client: {
      name: "PLAINEMAISON OCCITANIE",
      address: "LES SEGUINES",
      city: "PUISSERGUIER",
      postalCode: "34620",
    },
    contact: {
      name: "BOB FLORIN MARIJAN",
      role: "Agent de jour commerçant",
    },
    dates: {
      start: "24/01/2023",
      end: "24/01/2024",
    },
  },
  {
    id: "2",
    contractNumber: "2023-0002",
    company: {
      name: "J'M INTERIM",
      agencyNumber: "15872",
    },
    client: {
      name: "PLAINEMAISON OCCITANIE",
      address: "AGENCE D'EN ALBASAC",
      city: "ALBASAC",
      postalCode: "34620",
    },
    contact: {
      name: "LEAMLYNCH OLIVIER",
      role: "Agent de production et de conditionnement",
    },
    dates: {
      start: "24/01/2023",
      end: "24/01/2024",
    },
  },
  {
    id: "3",
    contractNumber: "2023-0003",
    company: {
      name: "J'M INTERIM",
      agencyNumber: "15872",
    },
    client: {
      name: "PLAINEMAISON OCCITANIE",
      address: "AGENCE D'EN ALBASAC",
      city: "ALBASAC",
      postalCode: "34620",
    },
    contact: {
      name: "BATIS HAMID MOHAMED",
      role: "Agent de production et de conditionnement (emballeur)",
    },
    dates: {
      start: "17/02/2023",
      end: "21/02/2023",
    },
  },
  {
    id: "4",
    contractNumber: "2023-0004",
    company: {
      name: "J'M INTERIM",
      agencyNumber: "15872",
    },
    client: {
      name: "PLAINEMAISON OCCITANIE",
      address: "AGENCE D'EN ALBASAC",
      city: "ALBASAC",
      postalCode: "34620",
    },
    contact: {
      name: "MIAIMAIRIA YVES",
      role: "Agent de production et de conditionnement (emballeur)",
    },
    dates: {
      start: "15/01/2023",
      end: "21/03/2023",
    },
  },
];

const tabs = [
  {
    id: "informations",
    label: "INFORMATIONS",
    icon: getTabIcon("informations"),
  },
  { id: "contact", label: "CONTACT", icon: getTabIcon("contact") },
  { id: "evenement", label: "ÉVÉNEMENT", icon: getTabIcon("evenement") },
  { id: "devis", label: "DEVIS", icon: getTabIcon("devis") },
  { id: "atradius", label: "ATRADIUS", icon: getTabIcon("atradius") },
  { id: "fichiers", label: "FICHIERS", icon: getTabIcon("fichiers") },
  {
    id: "commentaires",
    label: "COMMENTAIRES",
    icon: getTabIcon("commentaires"),
  },
  { id: "contrat", label: "CONTRAT", icon: getTabIcon("contrat") },
  { id: "factures", label: "FACTURES", icon: getTabIcon("factures") },
  {
    id: "notation",
    label: "NOTATIONS",
    icon: getTabIcon("devis"),
  },
];

const sideMenuItems = [
  {
    id: "demander-code",
    label: "Demander code atradius",
    onClick: () => console.log("Demander code atradius"),
    color: "bg-blue-100 text-blue-700 hover:bg-blue-200",
  },
  {
    id: "faire-devis",
    label: "Faire un devis",
    onClick: () => console.log("Faire un devis"),
    color: "bg-purple-100 text-purple-700 hover:bg-purple-200",
  },
  {
    id: "creer-vacations",
    label: "Créer vacations / placement",
    onClick: () => console.log("Créer vacations / placement"),
    color: "bg-green-100 text-green-700 hover:bg-green-200",
  },
  {
    id: "creer-contrat",
    label: "Créer contrat interim",
    onClick: () => console.log("Créer contrat interim"),
    color: "bg-yellow-100 text-yellow-700 hover:bg-yellow-200",
  },
  {
    id: "generer-fiche",
    label: "Générer fiche de renseignement",
    onClick: () => console.log("Générer fiche de renseignement"),
    color: "bg-pink-100 text-pink-700 hover:bg-pink-200",
  },
  {
    id: "epi",
    label: "EPI",
    onClick: () => console.log("EPI"),
    color: "bg-gray-200 text-gray-700 hover:bg-gray-300",
  },
];

const mockScheduleEntries = [
  {
    id: "1",
    title: "Mission opérateur production",
    type: "mission",
    startDate: "15/04/2023",
    endDate: "30/05/2023",
    location: "Site principal PLAINEMAISON - Puisserguier",
    status: "confirmed",
    interimaires: ["Bernard Antoine", "Girard Pierre", "Lopez Maria"],
  },
  {
    id: "2",
    title: "Rendez-vous commercial",
    type: "rendezvous",
    startDate: "20/04/2023",
    endDate: "20/04/2023",
    location: "Bureau client",
    contact: "Laurent Dupont",
    status: "confirmed",
  },
  {
    id: "3",
    title: "Formation sécurité",
    type: "formation",
    startDate: "10/04/2023",
    endDate: "10/04/2023",
    location: "Site principal PLAINEMAISON - Puisserguier",
    status: "completed",
    interimaires: ["Bernard Antoine", "Girard Pierre"],
  },
  {
    id: "4",
    title: "Visite évaluation site",
    type: "autre",
    startDate: "18/04/2023",
    endDate: "18/04/2023",
    location: "Site secondaire PLAINEMAISON - Béziers",
    status: "pending",
  },
];

const mockEvents = [
  {
    id: "1",
    title: "Réunion trimestrielle avec PLAINEMAISON",
    type: "commercial",
    date: "25/04/2023",
    time: "14:30",
    location: "Siège PLAINEMAISON - Salle Méditerranée",
    attendees: [
      "Laurent Dupont",
      "Sophie Martin",
      "Marie Dubois",
      "Jean Girard",
    ],
    description:
      "Point sur les missions en cours et présentation des besoins pour le trimestre à venir.",
    status: "upcoming",
  },

  {
    id: "2",
    title: "Signature contrat extension site Béziers",
    type: "administratif",
    date: "18/04/2023",
    time: "10:00",
    location: "Site PLAINEMAISON Béziers",
    attendees: ["Laurent Dupont", "Marie Dubois"],
    description:
      "Signature du contrat pour l'extension des services sur le site de Béziers.",
    status: "upcoming",
  },
  {
    id: "3",
    title: "Formation nouveaux intérimaires",
    type: "social",
    date: "12/04/2023",
    time: "09:00",
    location: "Site PLAINEMAISON Puisserguier",
    attendees: ["Thomas Leroy", "Sophie Klein"],
    description:
      "Session d'accueil et de formation pour les nouveaux intérimaires.",
    status: "completed",
  },
  {
    id: "4",
    title: "Call de suivi hebdomadaire",
    type: "autre",
    date: "10/04/2023",
    time: "11:00",
    attendees: ["Laurent Dupont", "Jean Girard"],
    description: "Point hebdomadaire sur les missions en cours.",
    status: "completed",
  },
];

export default function ClientDetails() {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("informations");
  const [quotations, setQuotations] = useState([]);
  const [originalQuotations, setOriginalQuotations] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenCreateClient, setIsOpenCreateClient] = useState(false);
  const [selectedContractId, setSelectedContractId] = useState("");
  const [clients, setClients] = useState([]);
  const [originalClients, setOriginalClients] = useState([]);
  const [timer, setTimer] = useState(null);
  const [isCreateDevis, setIsCreateDevis] = useState(false);
  const [isLoadingDevis,setIsLoadingDevis ] = useState(false);

  const [documentToUploadType, setDocumentToUploadType] = useState("");
  const [files, setFiles] = useState([]); // Tous les fichiers du client
  const [openAddModal, setOpenAddModal] = useState(false); // Modale d'ajout
  const [selectedClient, setSelectedClient] = useState(null);
  const [cover, setCover] = useState(null);
  const [loadedCover, setLoadedCover] = useState(false);
  // Contact state management
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(undefined);
  const [otherDocumentType, setOtherDocumentType] = useState("");
  const [candSelectedOptions, setCandSelectedOptions] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);

  // Files state management
  const [isFileUploadOpen, setIsFileUploadOpen] = useState(false);
  const [selectedFileCategory, setSelectedFileCategory] = useState("all");

  // Invoices state management
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState("all");

  // Schedule state management
  const [scheduleEntries, setScheduleEntries] = useState(mockScheduleEntries);
  const [selectedScheduleType, setSelectedScheduleType] = useState("all");

  // Notes state management
  const [notes, setNotes] = useState([]);
  const [isNoteFormOpen, setIsNoteFormOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState(undefined);

  // Events state management
  const [events, setEvents] = useState(mockEvents);
  const [selectedEventStatus, setSelectedEventStatus] = useState("all");

  // Quotes state management
  const [quotes, setQuotes] = useState([]);


  const [contracts, setContracts] = useState([]);

  // Atradius state management

  const [selectedAtradiusStatus, setSelectedAtradiusStatus] = useState("all");

  // Comments state management
  const [comments, setComments] = useState(
    selectedClient ? selectedClient.comments : [],
  );
  const [commentaire, setCommentaire] = useState("");
  const [isCommentFormOpen, setIsCommentFormOpen] = useState(false);
  const [selectedComment, setSelectedComment] = useState(undefined);
  const [replyToCommentId, setReplyToCommentId] = useState(undefined);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);

  //company
  const [siret, setSiret] = useState("");
  const [denomination, setDenomination] = useState("");
  const [ape, setApe] = useState("");
  const [address, setAddress] = useState("");
  const [town, setTown] = useState("");
  const [postCode, setPostCode] = useState("");
  const [tva, setTva] = useState("");
  const [tvaRate, setTvaRate] = useState("");
  const [paymentCondition, setPaymentCondition] = useState("");
  const [pld, setPld] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  //ADRESSES

  const [addressLivraison, setAddressLivraison] = useState("");
  const [postCodeLivraison, setPostcodeLivraison] = useState("");
  const [townLivraison, setTownLivraison] = useState("");

  const [addressFacturation, setAddressFacturation] = useState("");
  const [postcodeFacturation, setPostcodeFacturation] = useState("");
  const [townFacturation, setTownFacturation] = useState("");

  //contact
  const [contactFirstname, setContactFirstname] = useState("");
  const [contactLastname, setContactLastname] = useState("");
  const [contactEMail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");

  //facturation

  const [facturation, setFacturation] = useState("");

  const cancelButtonRef = useRef(null);

  const [isContact, setIsContact] = useState(false);
  const [isCompany, setIsCompany] = useState(true);
  const [isAddress, setIsAddress] = useState(false);
  const [isFacturation, setIsFacturation] = useState(false);

  const paymentConditions = [
    "À Réception",
    "À 10 jours",
    "À 15 jours",
    "Fin de mois",
    "30 jours date de facture",
    "30 jours fdm",
    "30 jours fdm le 5",
    "30 jours fdm le 10",
    "30 jours fdm le 15",
    "30 jours fdm le 20",
    "30 jours fdm le 25",
    "À 45 jours",
    "À 45 jours fdm",
    "60 jours date de facture",
    "60 jours fdm",
    "60 jours fdm le 5",
    "60 jours fdm le 10",
    "60 jours fdm le 15",
    "60 jours fdm le 20",
    "60 jours fdm le 25",
  ];

  const TVA = [
    "TVA 20%",
    "TVA 10%",
    "TVA 8.5%",
    "TVA 5.5%",
    "TVA 2.1%",
    "TVA 0% UE",
    "TVA 0% HORS UE",
  ];

  const tvaArray = TVA.map((tva) => {
    return {
      value: tva,
      label: tva,
    };
  });

  const paymentConditionArray = paymentConditions.map((paymentCondition) => {
    return {
      value: paymentCondition,
      label: paymentCondition,
    };
  });

  const openModal = () => {
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const loadClients = () => {
    axios
      .get("client/freelance")
      .then((res) => {
        setClients(res.data);
        setOriginalClients(res.data);
        console.log("Clients dans ClientDetails:", clients);
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setIsLoading(false);
      });
  };
  function splitStringWithoutCuttingWords(inputString, chunkSize) {
    const words = inputString.split(" ");
    const resultChunks = [];
    let currentChunk = "";

    for (const word of words) {
      if (currentChunk.length + word.length <= chunkSize) {
        currentChunk += (currentChunk ? " " : "") + word;
      } else {
        resultChunks.push(currentChunk);
        currentChunk = word;
      }
    }

    if (currentChunk) {
      resultChunks.push(currentChunk);
    }

    return resultChunks;
  }
  const updateClient = () => {
    if (!selectedClient) {
      console.error("Aucun client sélectionné.");
      return;
    }

    let newComment = {
      comment: commentaire,
      createdAt: Date.now(),
      commentator: localStorage.getItem("name"),
    };

    axios
      .post(`client/${selectedClient._id}/update-comment`, {
        comments: [newComment, ...comments],
      })
      .then((res) => {
        message.success("Commentaire ajouté !");
        // Mettre à jour les commentaires localement si besoin
        setComments([newComment, ...comments]);
        setCommentaire(""); // vider le champ commentaire
      })
      .catch((err) => {
        message.error("Erreur lors de l'ajout du commentaire.");
        console.error(err);
      });
  };


  const loadContracts = (clientPld) => {
    if(!clientPld)return;
    axios
      .get(`/pld-contract/admin/client/${clientPld}`)
      .then((res) => setContracts(res.data))
      .catch(() => message.error("Erreur lors du chargement des fichiers"));
  };

  const loadFiles = (clientId) => {
    axios
      .get(`/client-document/client/${clientId}`)
      .then((res) => setFiles(res.data))
      .catch(() => message.error("Erreur lors du chargement des fichiers"));
  };
  const getCover = (clientId) => {
    axios
      .get(`cover/client/${clientId}`)
      .then((res) => {
        console.log("Cover data :", res.data);
        if (res.data.length) {
          setCover(res.data[0]);
        } else {
          setCover(null); // Pas de cover
        }
      })
      .catch((e) => {
        console.log(e);
        setCover(null); // Erreur → pas de cover
      })
      .finally(() => setLoadedCover(true));
  };

  useEffect(() => {
    loadClients();
  }, []);

 

  // Ratings state management
  const [ratings, setRatings] = useState([
    {
      id: "1",
      interimaireName: "Bernard Antoine",
      internalRating: 4.5,
      clientRating: 4.0,
      lastMission: "15/04/2023 - 30/05/2023",
      comments:
        "Très bon travail, ponctuel et efficace. Particulièrement doué pour le travail en équipe.",
      skills: ["Manutention", "Cariste", "Logistique"],
    },
  ]);
  const [selectedRatingFilter, setSelectedRatingFilter] = useState("all");
  const [selectedRating, setSelectedRating] = useState(undefined);

  const filteredRatings =
    selectedRatingFilter === "all"
      ? ratings
      : selectedRatingFilter === "high"
        ? ratings.filter((rating) => rating.clientRating >= 4)
        : selectedRatingFilter === "medium"
          ? ratings.filter(
              (rating) => rating.clientRating >= 3 && rating.clientRating < 4,
            )
          : ratings.filter((rating) => rating.clientRating < 3);

  // Handle tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  // Handle contract action
  const handleContractAction = (contractId) => {
    setSelectedContractId(contractId);
    setIsModalOpen(true);
  };

  // Contact handlers
  const handleAddContact = () => {
    setSelectedContact(undefined);
    setIsContactFormOpen(true);
  };

  // File handlers
  const handleFileUpload = (formData) => {
    // In a real application, this would send the file to the server
    // For now, we'll just add a mock file to our list
    const file = formData.get("file");
    const category = formData.get("category");

    const newFile = {
      id: `${Date.now()}`,
      name: file ? file.name : "Nouveau fichier.pdf",
      type: file ? file.name.split(".").pop() || "pdf" : "pdf",
      category: category || "Document administratif",
      size: file ? `${(file.size / 1024).toFixed(1)} KB` : "0 KB",
      uploadDate: new Date().toLocaleDateString("fr-FR"),
      uploadedBy: "Utilisateur actuel",
      status: "active",
    };

    setFiles([newFile, ...files]);
    setIsFileUploadOpen(false);
  };

  const handleViewFile = (id) => {
    // In a real application, this would open the file viewer
    console.log(`View file ${id}`);
  };

  const handleDownloadFile = (id) => {
    // In a real application, this would trigger the file download
    console.log(`Download file ${id}`);
  };

  const handleArchiveFile = (id) => {
    setFiles(
      files.map((file) =>
        file.id === id ? { ...file, status: "archived" } : file,
      ),
    );
  };

  const filteredFiles =
    selectedFileCategory === "all"
      ? files
      : files.filter((file) => file.category === selectedFileCategory);

  // Invoice handlers
  const handleViewInvoice = (id) => {
    // In a real application, this would open the invoice viewer
    console.log(`View invoice ${id}`);
  };

  const handleDownloadInvoice = (id) => {
    // In a real application, this would trigger the invoice download
    console.log(`Download invoice ${id}`);
  };

  const handlePayInvoice = (id) => {
    // In a real application, this would open the payment form
    console.log(`Pay invoice ${id}`);
  };

  const filteredInvoices =
    selectedInvoiceStatus === "all"
      ? invoices
      : invoices.filter((invoice) => invoice.status === selectedInvoiceStatus);

  // Schedule handlers
  const handleClickScheduleEntry = (id) => {
    // In a real application, this would open the schedule entry details
    console.log(`Click schedule entry ${id}`);
  };

  const filteredScheduleEntries =
    selectedScheduleType === "all"
      ? scheduleEntries
      : scheduleEntries.filter((entry) => entry.type === selectedScheduleType);

  // Note handlers
  const handleAddNote = () => {
    setSelectedNote(undefined);
    setIsNoteFormOpen(true);
  };

  const handleEditNote = (noteId) => {
    const note = notes.find((n) => n.id === noteId);
    setSelectedNote(note);
    setIsNoteFormOpen(true);
  };

  const handleDeleteNote = (noteId) => {
    setNotes(notes.filter((note) => note.id !== noteId));
  };

  const handleSaveNote = (noteData) => {
    if (selectedNote) {
      // Edit existing note
      setNotes(
        notes.map((n) =>
          n.id === selectedNote.id ? { ...n, ...noteData } : n,
        ),
      );
    } else {
      // Add new note
      const newNote = {
        id: `${Date.now()}`,
        content: noteData.content || "",
        createdBy: "Utilisateur actuel",
        createdAt: new Date().toLocaleString("fr-FR"),
        category: noteData.category,
        priority: noteData.priority,
        tags: noteData.tags,
      };
      setNotes([newNote, ...notes]);
    }
    setIsNoteFormOpen(false);
  };

  // Event handlers
  const handleClickEvent = (id) => {
    // In a real application, this would open the event details
    console.log(`View event ${id}`);
  };
  const loadQuotations = (clientId) => {
    axios
      .get(`quotation/client/${clientId}`)
      .then((res) => {
        const quotations = res.data.sort(
          (a, b) => b.quotationNumber - a.quotationNumber,
        );
        setQuotations(quotations);
        setOriginalQuotations(quotations);
        console.log(res.data);
        console.log(quotations);
      })
      .catch((e) => {
        message.error("erreur");
      });
  };
  const filteredEvents =
    selectedEventStatus === "all"
      ? events
      : events.filter((event) => event.status === selectedEventStatus);

  // Quote handlers
  const handleViewQuote = (id) => {
    // In a real application, this would open the quote viewer
    console.log(`View quote ${id}`);
  };

  const handleDownloadQuote = (id) => {
    // In a real application, this would trigger the quote download
    console.log(`Download quote ${id}`);
  };

  const handleAcceptQuote = (id) => {
    setQuotes(
      quotes.map((quote) =>
        quote.id === id ? { ...quote, status: "accepted" } : quote,
      ),
    );
  };

  const handleRejectQuote = (id) => {
    setQuotes(
      quotes.map((quote) =>
        quote.id === id ? { ...quote, status: "rejected" } : quote,
      ),
    );
  };

  // Atradius handlers
  const handleViewAtradius = (id) => {
    // In a real application, this would open the Atradius request details
    console.log(`View Atradius request ${id}`);
  };

  const handleCheckAtradius = (id) => {
    // In a real application, this would check the status with Atradius
    console.log(`Check status of Atradius request ${id}`);
  };

  // Comment handlers
  const handleAddComment = () => {
    setSelectedComment(undefined);
    setReplyToCommentId(undefined);
    setIsCommentFormOpen(true);
  };

  const handleReplyToComment = (commentId) => {
    setSelectedComment(undefined);
    setReplyToCommentId(commentId);
    setIsCommentFormOpen(true);
  };

  const handleEditComment = (commentId) => {
    const comment = comments.find((c) => c.id === commentId);
    setSelectedComment(comment);
    setReplyToCommentId(undefined);
    setIsCommentFormOpen(true);
  };

  const handleDeleteComment = (commentId) => {
    setComments(comments.filter((comment) => comment.id !== commentId));
  };

  const handleSaveComment = (commentData) => {
    const newComment = {
      comment: commentData.comment,
      createdAt: Date.now(),
      commentator: localStorage.getItem("firstname"),
    };

    axios
      .post(`client/${selectedClient._id}/update-comment`, {
        comments: [newComment, ...comments],
      })
      .then((res) => {
        message.success("Commentaire ajouté !");

        // Mettre à jour les comments visibles
        setComments([newComment, ...comments]);

        // Mettre à jour la liste des clients (très important pour la persistance après reload)
        const clientIndex = clients.findIndex((cl) => cl._id === res.data._id);
        const newClients = [...clients];
        newClients[clientIndex] = res.data;
        setClients(newClients);

        // Fermer la modal
        setIsCommentFormOpen(false);
      })
      .catch((e) => {
        if (e.response?.data?.statusCode === 403) {
          localStorage.clear();
          navigate("/login");
        }
      });
  };
  const formatJsDate2 = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const generatePDF = (quotation) => {
    
    setIsLoadingDevis(true);
    const pdf = new jsPDF({
      unit: "mm",
      format: [210, 297],
    });

    if (quotation.agency.name === "CAPENEO")
      pdf.addImage(propositionCapeneo, "PNG", 0, 0, 210, 297);
    else if (quotation.agency.name === "J'M CAPENEO")
      pdf.addImage(propositionCapeneo, "PNG", 0, 0, 210, 297);
    else pdf.addImage(propositionJminterim, "PNG", 0, 0, 210, 297);

    pdf.addPage();

    const img = new Image();
    if (quotation.agency.name === "CAPENEO") {
      img.src = logotoulouse;
      pdf.addImage(img, "PNG", 14, 10, 40, 24);
    } else if (quotation.agency.name === "J'M CAPENEO") {
      img.src = logobrive;
      pdf.addImage(img, "PNG", 24, 14, 32, 24);
    } else {
      img.src = myImage;
      pdf.addImage(img, "PNG", 14, 10, 40, 24);
    }

    const gmailImg = new Image();
    gmailImg.src = gmail;

    const phoneImg = new Image();
    phoneImg.src = phone;

    pdf.setFontSize(14);
    pdf.setFont("Helvetica", "Bold");
    pdf.text(quotation.agency.name, 24, 45);
    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    pdf.text(quotation.agency.address, 15, 50);
    pdf.text(quotation.agency.postCode + " " + quotation.agency.town, 15, 55);
    pdf.text("SIRET  : " + quotation.agency.siret, 15, 60);
    pdf.text("TVA n° : " + quotation.agency.tva, 15, 65);
    pdf.addImage(gmailImg, "PNG", 15, 67, 3, 3);

    pdf.text(" : " + quotation.agency.email, 18, 69.5);
    pdf.addImage(phoneImg, "PNG", 15, 71.5, 3, 3);
    pdf.text(" : " + quotation.agency.phone, 18, 74);
    const contactName =
      "Contact : " +
      quotation.creator.firstname.charAt(0).toUpperCase() +
      quotation.creator.firstname.slice(1) +
      " " +
      quotation.creator.lastname.charAt(0).toUpperCase() +
      quotation.creator.lastname.slice(1);
    pdf.text(contactName, 15, 79.5);

    pdf.setFontSize(14);
    pdf.setFont("Helvetica", "Bold");
    let quotationNumber =
      "Devis n° " +
      formatJsDate2(quotation.createdAt) +
      "-" +
      quotation.quotationNumber?.toString().padStart(5, 0);
    if (quotation.isDraft) quotationNumber = "Devis provisoire";
    pdf.text(quotationNumber, 110, 45);

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");

    pdf.text("Date : ", 110, 50);
    pdf.text(formatJsDate(quotation.createdAt), 120, 50);

    pdf.text("Date d'expiration :", 110, 55);
    pdf.text(formatJsDate(quotation.expiryDate), 137, 55);

    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "Bold");
    pdf.text("Adresse de facturation :", 15, 95);

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    var [partieAvant, codePostal, partieApres] = quotation.addressFacturation
      .trim()
      .match(/^(.*?)\b(\d{5})\b(.*)$/)
      .slice(1)
      .map((str) => str.trim());
    try {
      pdf.text(partieAvant, 15, 100);
      pdf.text(codePostal + " " + partieApres, 15, 105);
    } catch (e) {
      console.log(e);
    }

    pdf.setFontSize(12);
    pdf.setFont("Helvetica", "Bold");

    const companyNameArray = splitStringWithoutCuttingWords(
      quotation.client.companyName.toUpperCase(),
      30,
    );
    let size = 80 - (companyNameArray.length - 1) * 5;
    for (let name of companyNameArray) {
      pdf.text(name, 110, size);
      size += 5;
    }

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    console.log(quotation.contact.split(" "));

    let contact = quotation.contact.split(" ");
    contact.pop();
    contact.pop();
    contact = contact.join(" ").trim();

    pdf.text(`${contact.toUpperCase()}`, 110.5, 85);
    pdf.text(partieAvant, 110.5, 90);
    pdf.text(codePostal + " " + partieApres, 110.5, 95);
    pdf.text("SIRET : " + quotation.client.siret, 110.5, 100);
    pdf.text("TVA : " + quotation.client.TVA, 110.5, 105);

    pdf.setFontSize(12);
    pdf.setFont("Helvetica", "bold");
    pdf.setTextColor(9, 132, 227);
    pdf.setDrawColor(9, 132, 227);

    if (
      quotation.products[0].product === "Placement" ||
      quotation.products[0].product === "Vacation"
    ) {
      pdf.roundedRect(26, 115, 160, 30, 1, 1);
      pdf.text(quotation.products[0].product.toUpperCase(), 95, 120);
      pdf.line(95, 122, 122, 122);

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);

      pdf.text(
        "Vous nous mandatez pour recruter au sein de votre entreprise, un poste en CDD ou CDI.",
        46,
        130,
      );
      pdf.text(
        "Le contrat, la DPAE et la fiche de paie sont établis par vos soins. Vous êtes l'employeur.",
        46,
        135,
      );
      pdf.text("Vous recevrez une seule facture pour le placement", 57, 140);
    }

    if (
      quotation.products[0].product === "Délégation" ||
      quotation.products[0].product === "Gestion"
    ) {
      pdf.roundedRect(15, 110, 92, 35, 1, 1);
      pdf.roundedRect(110, 110, 92, 35, 1, 1);
      pdf.text("DELEGATION", 47, 115);
      pdf.line(47, 117, 75, 117);
      pdf.text("GESTION", 145, 115);
      pdf.line(145, 117, 164, 117);

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);

      pdf.text("Vous nous mandatez pour", 17, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("recruter", 55, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text("   et", 65, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("  gérer", 70, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text(" l'administratif", 80, 125);
      pdf.text("de ", 17, 130);
      pdf.setFont("Helvetica", "bold");
      pdf.text("notre", 21, 130);
      pdf.setFont("Helvetica", "normal");
      pdf.text("recrue. Le contrat, la DPAE et la fiche de paie sont", 30, 130);
      pdf.text(
        "établis par nous, qui sommes l'employeur. Vous avez à charge",
        17,
        135,
      );
      pdf.text(
        "la sécurité du salarié. Vous recevrez une facture mensuelle.",
        17,
        140,
      );

      pdf.text("Vous nous mandatez pour", 112, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("gérer", 150, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text("simplement l'administratif", 159, 125);
      pdf.text("de", 112, 130);
      pdf.setFont("Helvetica", "bold");
      pdf.text("votre", 116, 130);
      pdf.setFont("Helvetica", "normal");
      pdf.text(
        "recrue. Le contrat, la DPAE et la fiche de paie sont",
        125,
        130,
      );
      pdf.text(
        "établis par nous, qui sommes l'employeur. Vous avez à charge",
        112,
        135,
      );
      pdf.text(
        "la sécurité du salarié. Vous recevrez une facture mensuelle.",
        112,
        140,
      );
    }

    pdf.setTextColor(0, 0, 0);

    pdf.setFillColor(9, 132, 227);
    pdf.setDrawColor(9, 132, 227);
    pdf.rect(15, 155, 180, 10, "F");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "bold");

    if (
      quotation.products[0].product === "Délégation" ||
      quotation.products[0].product === "Gestion"
    ) {
      let height = 170;

      pdf.text("Designation", 25, 161);
      pdf.text("Taux horaire", 60, 161);
      pdf.text("Coefficient", 95, 161);
      pdf.text("Prix HT/heure", 130, 159);
      pdf.text("travaillée", 135, 163);
      pdf.text("Observation", 165, 161);

      pdf.setFontSize(10);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);

      quotation.products.map((product, idx) => {
        if (product.type === "Prime") {
          const prime = splitStringWithoutCuttingWords(
            "Prime : " + product.product,
            24,
          );
          for (let i = 0; i < prime.length; i++) {
            pdf.text(prime[i], 20, height);
            height += 5;
          }
          height -= 5;
        } else if (product.type === "Indemnité") {
          const indemnite = splitStringWithoutCuttingWords(
            "Indemnité : " + product.product,
            24,
          );
          for (let i = 0; i < indemnite.length; i++) {
            pdf.text(indemnite[i], 20, height);
            height += 5;
          }
          height -= 5;
        } else if (product.type === "Autre")
          pdf.text(product.product, 20, height);
        else {
          pdf.text(product.product + " H/F", 20, height);
          const poste = splitStringWithoutCuttingWords(product.poste, 24);
          for (let i = 0; i < poste.length; i++) {
            pdf.text(poste[i], 20, height + 5);
            height += 5;
          }
        }
        if (product.taux !== "")
          pdf.text(parseFloat(product.taux).toFixed(2) + "€", 65, height);
        if (product.coefficient !== "")
          pdf.text(product.coefficient, 105, height);
        if (product.taux !== "" && product.coefficient !== "")
          pdf.text(
            (
              parseFloat(product.taux) * parseFloat(product.coefficient)
            ).toFixed(2) + "€",
            140,
            height,
          );
        const comment = splitStringWithoutCuttingWords(product.comment, 24);
        for (let i = 0; i < comment.length; i++) {
          pdf.text(comment[i], 165, height);
          height += 5;
        }
        height += 5;
        pdf.setTextColor(128, 128, 128);
        pdf.setDrawColor(128, 128, 128);
        if (product.minimumHours) {
          pdf.text(
            "Nombre d'heures minimales avant embauche sans facturation : " +
              product.minimumHours +
              "h",
            50,
            height,
          );
          height += 3;
        }

        if (idx === quotation.products.length - 1) {
          pdf.setDrawColor(0, 0, 0);
          pdf.setLineWidth(0.5);
        }
        pdf.line(15, height, 195, height);
        pdf.setTextColor(0, 0, 0);
        pdf.setDrawColor(0, 0, 0);
        height += 7;
        if (height > 260) {
          pdf.addPage();
          height = 10;
        }
      });

      height += 10;
      if (height > 250) {
        pdf.addPage();
        height = 10;
      }

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");

      pdf.text("Nom et qualité du signataire :", 15, height);
      pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);

      pdf.text(quotation.client.tvaRate, 120, height);
      pdf.text(
        "Conditions de paiement : " + quotation.client.facturation,
        120,
        height + 5,
      );
      pdf.text("Moyen de règlement : Virement/Chèque/CB", 120, height + 10);
    }

    if (
      quotation.products[0].product === "Placement" ||
      quotation.products[0].product === "Vacation"
    ) {
      let height = 170;

      pdf.text("Designation", 25, 161);
      pdf.text("Quantité", 68, 161);
      pdf.text("PU (HT)", 110, 161);
      pdf.text("Montant (HT)", 160, 161);

      pdf.setFontSize(10);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);

      quotation.products.map((product, idx) => {
        pdf.text(product.product + " H/F", 20, height);
        pdf.text(product.poste, 20, height + 5);
        height += 5;
        console.log(product.taux);
        console.log(product.coefficient);
        if (product.taux !== "")
          pdf.text(parseFloat(product.taux).toFixed(2) + "€", 110, height);
        if (product.coefficient !== "")
          pdf.text(product.coefficient, 75, height);
        if (product.taux !== "" && product.coefficient !== "")
          pdf.text(
            (
              parseFloat(product.taux) * parseFloat(product.coefficient)
            ).toFixed(2) + "€",
            175,
            height,
          );
        height += 5;
        pdf.setTextColor(128, 128, 128);
        pdf.setDrawColor(128, 128, 128);

        if (idx === quotation.products.length - 1) {
          pdf.setDrawColor(0, 0, 0);
          pdf.setLineWidth(0.5);
        }
        pdf.line(15, height, 195, height);
        pdf.setTextColor(0, 0, 0);
        pdf.setDrawColor(0, 0, 0);
        height += 7;
        if (height > 260) {
          pdf.addPage();
          height = 10;
        }
      });

      if (height > 250) {
        pdf.addPage();
        height = 10;
      }

      pdf.setFillColor(135, 177, 255);
      pdf.setDrawColor(9, 132, 227);
      height += 6;
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("Helvetica", "Bold");

      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "normal");

      pdf.text("Total HT", 110, height);
      pdf.text(
        quotation.products
          .reduce(
            (total, item) => total + parseFloat(item.taux) * item.coefficient,
            0,
          )
          .toFixed(2) + " €",
        174,
        height,
      );

      height += 10;

      pdf.text(
        (
          quotation.products.reduce(
            (total, item) => total + parseFloat(item.taux) * item.coefficient,
            0,
          ) * 0.2
        ).toFixed(2) + " €",
        174,
        height,
      );
      height += 10;
      pdf.setFillColor(9, 132, 227);
      pdf.rect(105, height - 7, 90, 10, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.text("Total TTC", 110, height);
      pdf.text(
        (
          parseFloat(
            quotation.products.reduce(
              (total, item) => total + parseFloat(item.taux) * item.coefficient,
              0,
            ) * 0.2,
          ) +
          parseFloat(
            quotation.products.reduce(
              (total, item) => total + parseFloat(item.taux) * item.coefficient,
              0,
            ),
          )
        ).toFixed(2) + " €",
        174,
        height,
      );

      pdf.setTextColor(0, 0, 0);

      height += 10;

      if (height >= 270) pdf.addPage();

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");

      /* let hauteur=35
      for(let x of comment2){
        pdf.text(x,18,height)
        height+=5
      }
      pdf.text(
        'Conditions de paiement : '+quotation.products[0].comment,
        18,
        height,
      )
      pdf.text('Moyens de règlement : Virement/Chèque/CB', 18, height+5)
      pdf.text(
        'Coordonnées bancaires Asnières : FR76 1005 7190 0300 0208 2410146 - CMCIFRPP',
        18,
        height+10,
      )
      pdf.text(
        'Coordonnées bancaires Brive / Toulouse : FR76 1005 7190 0300 0207 4100 156 - CMCIFRPP',
        18,
        height+15,
      )
      pdf.text('Nom et qualité du signataire :', 18, height+20)
      pdf.text('Date : ' + formatJsDate(new Date()), 18,  height+25) */

      if (height > 280) {
        pdf.addPage();
        height = 10;
      }

      const paymentCondition = splitStringWithoutCuttingWords(
        "Conditions de paiement : " +
          quotation.products[0].comment.replace(/\n/g, ""),
        70,
      );

      pdf.text("Nom et qualité du signataire :", 15, height);
      pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);

      pdf.text("Moyen de règlement : Virement/Chèque/CB", 90, height);
      for (let x of paymentCondition) {
        pdf.text(x, 90, height + 5);
        height += 4;
        if (height >= 280) {
          pdf.addPage();
          height = 10;
        }
      }
      if (quotation.products[0].product === "Placement") {
        const replaceCondition = splitStringWithoutCuttingWords(
          "Conditions de remplacement : " +
            quotation.products[0].comment2.replace(/\n/g, ""),
          70,
        );
        for (let x of replaceCondition) {
          pdf.text(x, 90, height + 10);
          height += 4;
          if (height >= 280) {
            pdf.addPage();
            height = 10;
          }
        }
      }
    }

    pdf.text(
      `J'm intérim - SAS au capital de 80 000 € - 4 Avenue Laurent Cély, Hall A, 92600 Asnières sur Seine, France`,
      25,
      280,
    );
    pdf.text(
      "SIRET : 91912551800010 - Code APE : 7820z - N° de TVA : FR52919125518",
      50,
      285,
    );

    pdf.addPage();
    if (quotation.agency.name === "CAPENEO") {
      pdf.addImage(cgptoulouse, "PNG", 10, 10, 198, 282);
    } else if (quotation.agency.name === "J'M CAPENEO") {
      pdf.addImage(cgpbrive, "PNG", 10, 10, 198, 282);
    } else {
      pdf.addImage(cgpasnieres, "PNG", 10, 10, 198, 282);
    }

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");
    setIsLoadingDevis(false);
  };

  const resetFields = () => {
    setIsAddress(false);
    setIsCompany(true);
    setIsContact(false);
    setIsFacturation(false);
    setIsOpenCreateClient(false);
  };

  const setSection = (section) => {
    if (section === "address") {
      if (
        !siret.length ||
        !denomination.length ||
        !ape.length ||
        !tva.length ||
        !address.length ||
        !postCode.length ||
        !town.length
      ) {
        message.error("remplissez tous les champs");
        return;
      }

      setIsAddress(true);
      setIsCompany(false);
      setIsContact(false);
      setIsFacturation(false);
    }

    if (section === "company") {
      setIsAddress(false);
      setIsCompany(true);
      setIsContact(false);
      setIsFacturation(false);
    }

    if (section === "contact") {
      if (
        !postCodeLivraison.length ||
        !postcodeFacturation.length ||
        !townLivraison.length ||
        !townFacturation.length ||
        !addressLivraison.length ||
        !addressFacturation.length
      ) {
        message.error("remplissez tous les champs");
        return;
      }

      setIsAddress(false);
      setIsCompany(false);
      setIsContact(true);
      setIsFacturation(false);
    }

    if (section === "facturation") {
      if (
        !contactEMail.length ||
        !contactFirstname.length ||
        !contactLastname.length ||
        !contactPhone.length
      ) {
        message.error("remplissez tous les champs");
        return;
      }

      setIsAddress(false);
      setIsCompany(false);
      setIsContact(false);
      setIsFacturation(true);
    }
  };

  const copySiegeAddressLivraison = () => {
    setAddressLivraison(address);
    setTownLivraison(town);
    setPostcodeLivraison(postCode);
  };

  const copySiegeAddressFacturation = () => {
    setAddressFacturation(address);
    setTownFacturation(town);
    setPostcodeFacturation(postCode);
  };

  const copyLivraisonFacturation = () => {
    setAddressFacturation(addressLivraison);
    setTownFacturation(townLivraison);
    setPostcodeFacturation(postCodeLivraison);
  };

  const selectFacturation = (e) => {
    setFacturation(e);
  };

  const addClient = () => {
    if (!facturation.length) {
      message.error("remplissez tous les champs");
      return;
    }

    axios
      .post("client", {
        siret,
        companyName: denomination,
        address: address,
        town: town,
        postCode: postCode,
        pld: pld,
        APE: ape,
        TVA: tva,
        addressLivraison,
        addressFacturation,
        postCodeLivraison,
        postCodeFacturation: postcodeFacturation,
        townLivraison,
        townFacturation,
        contacts: [
          {
            firstname: contactFirstname,
            lastname: contactLastname,
            email: contactEMail,
            mobile: contactPhone.split(" ").join(""),
          },
        ],
        contactFirstname,
        contactLastname,
        contactEMail,
        contactPhone,
        facturation,
        tvaRate,
      })
      .then((res) => {
        message.success("Client créé");
        console.log(res);
        const newClients = [...clients];
        newClients.push(res.data);
        setSection("company");
        setClients(newClients);
        setIsOpenModal(false);
      })
      .catch((e) => {
        if (e.response.data.statusCode === 403) {
          localStorage.clear();
          navigate("/login");
        } else if (e.response.data.statusCode === 409) {
          message.error("Le client existe deja!");
        }
      });
  };

  const searchClient = (word) => {
    if (word.length === 0) {
      setClients(originalClients);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        setIsLoadingSearch(true);
        axios
          .post("client/freelance/find-by-text", { query: word })
          .then((res) => {
            setClients(res.data);
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingSearch(false));
      }, 700);
      setTimer(timer2);
    }
  };

  function formatPhoneNumberFR(input) {
    if (!input) return "";

    // Supprime tout sauf les chiffres
    let digits = input.replace(/\D/g, "");

    // Gère les numéros qui commencent par +33
    if (digits.startsWith("33")) {
      digits = "0" + digits.slice(2);
    }

    // Prend les 10 premiers chiffres (en cas d'erreur ou texte trop long)
    digits = digits.slice(0, 10);

    // Formate : 01.23.45.67.89
    return digits.replace(/(\d{2})(?=\d)/g, "$1 ").slice(0, 14);
  }

  return (
    <div className="flex flex-col h-full  p-6 mb-6">
      {/*   {isOpenCreateClient && (
                <CreateClientModal
                 open={isOpenCreateClient}
                  task={null}
                  takers={[]}
                  isUpdating={false}
                  onOpenChange={setIsOpenCreateClient}
                  updateOnCreate={()=>{}}
                  />
              )} */}

      {isOpenCreateClient && (
        <CreateClientModal
          clients={clients}
          setClients={setClients}
          open={isOpenCreateClient}
          onOpenChange={() => setIsOpenCreateClient(false)}
        />
      )}

      {!selectedClient && (
        <div className="flex items-center space-x-2 mb-6">
          <UserCog size={36} className="text-blue-600" />
          <h1 className="text-2xl font-bold text-gray-800 ">Clients</h1>
        </div>
      )}

      {!selectedClient && (
        <h1 className="text-3xl font-bold mb-8 text-gray-800">
          Gestion des clients
        </h1>
      )}

      {!selectedClient && (
        <Tabs
          defaultValue="clients"
          //onValueChange={setActiveTab}
          className="w-full"
        >
          <div className="flex justify-between items-center mb-6">
            <TabsList className="bg-white border border-gray-200 rounded-md shadow-sm">
              <TabsTrigger
                value="clients"
                className="px-8 py-2.5 text-sm font-medium"
              >
                Clients
              </TabsTrigger>
              <TabsTrigger
                value="actionsCommerciales"
                className="px-8 py-2.5 text-sm font-medium"
              >
                Actions Commerciales
              </TabsTrigger>
            </TabsList>

            <div className="flex justify-end gap-2">
              <Button
                onClick={() => {
                  setIsOpenCreateClient(true);
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 font-medium text-sm rounded-md shadow-sm transition-colors duration-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 3a1 1 0 00-1 1v5H4a1 1 0 100 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5V4a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                Créer un client
              </Button>
            </div>
          </div>
        </Tabs>
      )}

      {isLoadingDevis &&
       <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <Loader2 className="h-16 w-16 text-white animate-spin" />
    </div>
      }

      {isLoadingSearch && (
        <div className="fixed inset-0 z-50 bg-black/20 flex justify-center items-center">
          <Loader2 className="animate-spin h-10 w-10 text-blue-600" />
        </div>
      )}

      {!selectedClient && (
        <div className="mb-8 p-4 w-3/5 bg-white shadow rounded-lg flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4">
          <div className="relative flex-grow w-full sm:w-auto">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <Input
              type="search"
              onChange={(e) => searchClient(e.target.value)}
              placeholder="Rechercher un client"
              className="pl-10 w-full"
            />
          </div>
        </div>
      )}

      {isLoading && (
        <div className="w-full flex justify-center items-center py-20">
          <Loader2 className="animate-spin h-10 w-10 text-blue-600" />
        </div>
      )}

      {!selectedClient && !isLoading && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {clients.map((client) => (
            <div
              key={client._id}
              onClick={() => {
                setSelectedClient(client);
                setComments(client.comments || []);
                loadQuotations(client._id);
                //loadFiles(client._id);
                loadContracts(client.pld);
                getCover(client._id);
              }}
              className="group cursor-pointer relative bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-lg hover:border-blue-500 transition-all duration-200 p-6 flex flex-col gap-4"
            >
              {/* Header */}
              <div className="flex items-center justify-between">
                <h3 className="text-xl uppercase font-semibold text-gray-800 group-hover:text-blue-600 transition-colors duration-200">
                  {client.companyName}
                </h3>

                {/* Optional status badge */}
                <span className="text-xs font-medium bg-blue-100 text-blue-700 px-3 py-1 rounded-full">
                  {client.status || "Client"}
                </span>
              </div>

              {/* Info section */}
              <div className="space-y-3 text-sm text-gray-600">
                <div className="flex items-start gap-2">
                  <PhoneIcon className="w-5 h-5 text-blue-500 mt-0.5" />
                  <span>
                    {formatPhoneNumberFR(client.contactPhone) || (
                      <em className="text-gray-400">Non renseigné</em>
                    )}
                  </span>
                </div>

                <div className="flex items-start gap-2">
                  <MailIcon className="w-5 h-5 text-green-500 mt-0.5" />
                  <span className="break-all line-clamp-1">
                    {client.contactEMail || (
                      <em className="text-gray-400">Non renseigné</em>
                    )}
                  </span>
                </div>

                <div className="flex items-start gap-2">
                  <MapPinIcon className="w-5 h-5 text-purple-500 mt-0.5" />
                  <span>
                    {client.address || (
                      <em className="text-gray-400">Non renseignée</em>
                    )}
                  </span>
                </div>
              </div>

              {/* Footer or Actions (optional) */}
              {/* <div className="pt-4 text-right">
      <button className="text-sm text-blue-600 hover:underline">Voir détails</button>
    </div> */}
            </div>
          ))}
        </div>
      )}

      {selectedClient && (
        <div className="flex-1 overflow-auto bg-white shadow rounded p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-2 uppercase">
              {selectedClient.companyName}
            </h2>
            <p className="text-sm text-gray-800">
              Commercial : {selectedClient.commercial}
            </p>

            <button
              onClick={() => {setSelectedClient(null);setActiveTab("informations")}}
              className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Retour à la liste
            </button>
          </div>

          <ClientTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          <div className="p-4">
            {activeTab === "informations" && (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    <ClientInfoCard title="INFORMATIONS ENTREPRISE">
      <InfoItem
        label="SIRET"
        value={selectedClient.siret}
        onChange={(val) => setSelectedClient({ ...selectedClient, siret: val })}
      />
      <InfoItem
        label="DATE DE CRÉATION"
        value={`Crée le ${formatJsDate(selectedClient.createdAt)}`}
        editable={false}
      />
    </ClientInfoCard>

    <ClientInfoCard title="CONTACT PRINCIPAL">
      <InfoItem
        label="NOM DU CONTACT"
        value={`${selectedClient.contactLastname}`}
        onChange={(val) =>
          setSelectedClient({ ...selectedClient, contactLastname: val })
        }
      />
      <InfoItem
        label="PRENOM DU CONTACT"
        value={`${selectedClient.contactFirstname}`}
        onChange={(val) =>
          setSelectedClient({ ...selectedClient, contactFirstname: val })
        }
      />
      <InfoItem
        label="TÉLÉPHONE"
        value={selectedClient.contactPhone}
        onChange={(val) =>
          setSelectedClient({ ...selectedClient, contactPhone: val })
        }
        //icon={/* svg phone icon */}
      />
      <InfoItem
        label="EMAIL"
        value={selectedClient.contactEMail}
        onChange={(val) =>
          setSelectedClient({ ...selectedClient, contactEMail: val })
        }
        //icon={/* svg email icon */}
      />
    </ClientInfoCard>

    <ClientInfoCard title="SIEGE">
      <InfoItem
        label="SIEGE"
        value={`${selectedClient.address} ${selectedClient.postCode} ${selectedClient.town}`}
        editable={false}
        //icon={/* svg location icon */}
      />
      <InfoItem
        label="LIVRAISON"
        value={`${selectedClient.addressLivraison} ${selectedClient.postCodeLivraison} ${selectedClient.townLivraison}`}
        editable={false}
        //icon={/* svg location icon */}
      />
      <InfoItem
        label="FACTURATION"
        value={`${selectedClient.addressFacturation} ${selectedClient.postCodeFacturation} ${selectedClient.townFacturation}`}
        editable={false}
        //icon={/* svg location icon */}
      />
    </ClientInfoCard>

    <ClientInfoCard title="CONTRATS ET FACTURATION" className="md:col-span-2">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div>
          <InfoItem
            label="PROVENANCE"
            value={selectedClient.clientAcquisition}
            onChange={(val) =>
              setSelectedClient({ ...selectedClient, clientAcquisition: val })
            }
          />
          <InfoItem
            label="TAUX DE TVA"
            value={selectedClient.tvaRate}
            onChange={(val) =>
              setSelectedClient({ ...selectedClient, tvaRate: val })
            }
          />
          <InfoItem
            label="TVA INTRA"
            value={selectedClient.TVA}
            onChange={(val) =>
              setSelectedClient({ ...selectedClient, TVA: val })
            }
          />
        </div>
        <div>
          <InfoItem
            label="CONDITIONS DE PAIEMENT"
            value={selectedClient.facturation}
            onChange={(val) =>
              setSelectedClient({ ...selectedClient, facturation: val })
            }
          />
          <InfoItem
            label="ATRADIUS"
            value={
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-800 text-white">
                Accordé
              </span>
            }
            editable={false}
          />
          <InfoItem
            label="ATRADIUS"
            value={
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-800 text-white">
                Refusé
              </span>
            }
            editable={false}
          />
          <InfoItem
            label="ATRADIUS"
            value={
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-black text-white">
                Non vérifié
              </span>
            }
            editable={false}
          />
        </div>
      </div>
    </ClientInfoCard>

    <ClientInfoCard title="NOTES" className="md:col-span-1">
      <div className="text-sm text-gray-600 space-y-1">
        {selectedClient.comments.map((comment, index) => (
          <p key={index}>• {comment.comment}</p>
        ))}
      </div>
    </ClientInfoCard>
  </div>
)}


            {activeTab === "contrat" && (
              <div>
              {isCreateDevis && <ContractModal quotations={quotations} setQuotations={setQuotations} client={selectedClient} isOpen={isCreateDevis} setIsOpen={setIsCreateDevis} />}
 
                <div className="flex justify-between items-center mb-6 px-6 pt-6">
                  <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Contrat(s) ({contracts.length})
                  </h2>
                </div>
                  <div className="flex space-x-2 items-center">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Rechercher..."
                        className="pl-8 pr-3 py-1.5 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                    </div>
                    
                    <Button onClick={()=> setIsCreateDevis(true)}>Créer un contrat</Button>
                  </div>
                </div>

                {/* Stats Cards */}
               {/*  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                  <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
                    <div className="p-5">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 bg-blue-100 rounded-full p-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-blue-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                          </svg>
                        </div>
                        <div className="ml-5 w-0 flex-1">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">
                              Contrats actifs
                            </dt>
                            <dd className="flex items-baseline">
                              <div className="text-2xl font-semibold text-gray-900">
                                4
                              </div>
                              <div className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <span className="sr-only">Augmentation</span>
                                <span>12%</span>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
                    <div className="p-5">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 bg-green-100 rounded-full p-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-green-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </div>
                        <div className="ml-5 w-0 flex-1">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">
                              Volume contractuel
                            </dt>
                            <dd className="flex items-baseline">
                              <div className="text-2xl font-semibold text-gray-900">
                                24 800 €
                              </div>
                              <div className="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <span className="sr-only">Augmentation</span>
                                <span>8.2%</span>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
                    <div className="p-5">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 bg-purple-100 rounded-full p-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-purple-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </div>
                        <div className="ml-5 w-0 flex-1">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">
                              Durée moyenne
                            </dt>
                            <dd className="flex items-baseline">
                              <div className="text-2xl font-semibold text-gray-900">
                                3.2 mois
                              </div>
                              <div className="ml-2 flex items-baseline text-sm font-semibold text-gray-500">
                                <span>par contrat</span>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="bg-white shadow-sm rounded-lg overflow-hidden border border-gray-200 mb-5">
                  {/* <div className="px-6 py-4 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-sm font-medium text-gray-700">
                      Contrats en cours
                    </h3>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      4 actifs
                    </span>
                  </div> */}
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead>
                        <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          <th className="px-4 py-3 border-b border-gray-200">
                            N° DE CONTRAT
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200">
                            INTÉRIMAIRE
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200">
                            PÉRIODE
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200">
                            STATUT
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200 text-center">
                            ACTIONS
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {contracts.map((contract) => (
                          <ClientContractRow
                            key={contract.id}
                            contract={contract}
                            onAction={handleContractAction}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/*   <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 mx-6 mb-6">
                  <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-sm font-medium text-gray-700">
                      Historique des contrats
                    </h3>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800 shadow-sm">
                      24 contrats
                    </span>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead>
                        <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          <th className="px-4 py-3 border-b border-gray-200">
                            N° DE CONTRAT
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200">
                            INTÉRIMAIRE
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200">
                            PÉRIODE
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200">
                            STATUT
                          </th>
                          <th className="px-4 py-3 border-b border-gray-200 text-center">
                            DÉTAILS
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        <tr className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">
                            2022-0456
                          </td>
                          <td className="px-4 py-3">
                            <div className="flex items-center">
                              <div className="text-sm font-medium text-gray-900">
                                Marie Dufour
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-600">
                            12/09/2022 - 15/12/2022
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              Terminé
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-center">
                            <button className="text-blue-600 hover:text-blue-800">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path
                                  fillRule="evenodd"
                                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                        <tr className="hover:bg-gray-50">
                          <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">
                            2022-0398
                          </td>
                          <td className="px-4 py-3">
                            <div className="flex items-center">
                              <div className="text-sm font-medium text-gray-900">
                                Thomas Leroy
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-600">
                            05/07/2022 - 30/08/2022
                          </td>
                          <td className="px-4 py-3 text-sm">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              Terminé
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-center">
                            <button className="text-blue-600 hover:text-blue-800">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path
                                  fillRule="evenodd"
                                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 text-center text-sm">
                    <button className="text-blue-600 hover:text-blue-800 font-medium">
                      Voir tous les contrats
                    </button>
                  </div>
                </div> */}
              </div>
            )}

            {activeTab === "contact" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Contacts ({selectedClient.contacts.length})
                  </h2>
                  <button
                    onClick={handleAddContact}
                    className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Ajouter un contact
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {(selectedClient.contacts || []).map((contact, index) => (
                    <ContactCard
                      key={index}
                      contact={contact}
                      onEdit={() => console.log("Modifier contact :", contact)}
                    />
                  ))}
                </div>
              </div>
            )}

            {activeTab === "fichiers" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Fichiers ({filteredFiles.length})
                  </h2>
                  <div className="flex items-center space-x-2">
                    <select
                      value={selectedFileCategory}
                      onChange={(e) => setSelectedFileCategory(e.target.value)}
                      className="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="all">Toutes les catégories</option>
                      <option value="Document administratif">
                        Documents administratifs
                      </option>
                      <option value="Contrat">Contrats</option>
                      <option value="Commercial">Commercial</option>
                      <option value="Finance">Finance</option>
                      <option value="Divers">Divers</option>
                    </select>
                    <button
                      onClick={() => setOpenAddModal(true)}
                      className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-1"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Insérer un document
                    </button>
                  </div>
                </div>

                <div className="space-y-3">
                  {filteredFiles.map((file) => (
                    <FileRow
                      key={file.id}
                      file={file}
                      onView={handleViewFile}
                      onDownload={handleDownloadFile}
                      onArchive={handleArchiveFile}
                    />
                  ))}
                </div>
              </div>
            )}

            {activeTab === "notation" && (
              <div>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Notation des intérimaires{" "}
                    <span className="ml-2 text-sm font-normal bg-gray-100 px-2.5 py-1 rounded-full text-gray-600">
                      ({filteredRatings.length})
                    </span>
                  </h2>
                  <div className="flex items-center gap-2">
                    <div className="relative w-56">
                      <input
                        type="text"
                        className="w-full pl-9 pr-4 py-2.5 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                        placeholder="Rechercher un intérimaire..."
                      />
                      <div className="absolute left-3 top-2.5 text-gray-400">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                    <select
                      value={selectedRatingFilter}
                      onChange={(e) => setSelectedRatingFilter(e.target.value)}
                      className="text-sm border border-gray-300 rounded-md px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                    >
                      <option value="all">Toutes les notations</option>
                      <option value="high">Notation élevée (4-5)</option>
                      <option value="medium">Notation moyenne (3-4)</option>
                      <option value="low">Notation basse (1-3)</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                  {filteredRatings.map((rating) => (
                    <RatingCard
                      key={rating.id}
                      rating={rating}
                      onEdit={(id) => console.log(`Edit rating ${id}`)}
                    />
                  ))}
                </div>
              </div>
            )}

            {activeTab === "factures" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Factures{" "}
                    <span className="ml-2 text-sm font-normal bg-gray-100 px-2.5 py-1 rounded-full text-gray-600">
                      ({filteredInvoices.length})
                    </span>
                  </h2>
                  <div className="flex items-center gap-2">
                    <div className="relative w-56">
                      <input
                        type="text"
                        className="w-full pl-9 pr-4 py-2.5 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                        placeholder="Rechercher une facture..."
                      />
                      <div className="absolute left-3 top-2.5 text-gray-400">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                    <select
                      value={selectedInvoiceStatus}
                      onChange={(e) => setSelectedInvoiceStatus(e.target.value)}
                      className="text-sm border border-gray-300 rounded-md px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200"
                    >
                      <option value="all">Tous les statuts</option>
                      <option value="paid">Payées</option>
                      <option value="pending">En attente</option>
                      <option value="overdue">En retard</option>
                      <option value="canceled">Annulées</option>
                    </select>
                  </div>
                </div>

                <div className="bg-white shadow-sm rounded-lg overflow-hidden border border-gray-200">
                  <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-sm font-medium text-gray-700">
                      Liste des factures
                    </h3>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                      {filteredInvoices.length} factures
                    </span>
                  </div>
                  {filteredInvoices.length > 0 ? (
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead>
                          <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <th className="px-6 py-4 border-b border-gray-200">
                              N° DE FACTURE
                            </th>
                            <th className="px-4 py-3 border-b border-gray-200">
                              DATE
                            </th>
                            <th className="px-4 py-3 border-b border-gray-200">
                              ÉCHÉANCE
                            </th>
                            <th className="px-4 py-3 border-b border-gray-200">
                              PÉRIODE
                            </th>
                            <th className="px-4 py-3 border-b border-gray-200">
                              MONTANT
                            </th>
                            <th className="px-4 py-3 border-b border-gray-200">
                              STATUT
                            </th>
                            <th className="px-4 py-3 border-b border-gray-200 text-center">
                              ACTIONS
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {filteredInvoices.map((invoice) => (
                            <tr key={invoice.id} className="hover:bg-gray-50">
                              <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">
                                {invoice.number}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">
                                {invoice.date}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">
                                {invoice.dueDate}
                              </td>
                              <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">
                                {invoice.periodStart && invoice.periodEnd
                                  ? `${invoice.periodStart} - ${invoice.periodEnd}`
                                  : "-"}
                              </td>
                              <td className="px-4 py-3 text-sm font-medium whitespace-nowrap">
                                {new Intl.NumberFormat("fr-FR", {
                                  style: "currency",
                                  currency: "EUR",
                                }).format(invoice.amount)}
                              </td>
                              <td className="px-4 py-3 text-sm whitespace-nowrap">
                                <span
                                  className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium shadow-sm ${
                                    invoice.status === "paid"
                                      ? "bg-green-100 text-green-800"
                                      : invoice.status === "pending"
                                        ? "bg-yellow-100 text-yellow-800"
                                        : invoice.status === "overdue"
                                          ? "bg-red-100 text-red-800"
                                          : "bg-gray-100 text-gray-800"
                                  }`}
                                >
                                  {
                                    {
                                      paid: "Payée",
                                      pending: "En attente",
                                      overdue: "En retard",
                                      canceled: "Annulée",
                                    }[invoice.status]
                                  }
                                </span>
                              </td>
                              <td className="px-4 py-3 text-sm text-center">
                                <div className="flex justify-center space-x-2">
                                  <button
                                    onClick={() =>
                                      handleViewInvoice(invoice.id)
                                    }
                                    className="text-blue-600 hover:text-blue-800 transition-colors duration-200"
                                    title="Voir la facture"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </button>

                                  <button
                                    onClick={() =>
                                      handleDownloadInvoice(invoice.id)
                                    }
                                    className="text-purple-600 hover:text-purple-800 transition-colors duration-200"
                                    title="Télécharger la facture"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </button>

                                  {invoice.status === "pending" && (
                                    <button
                                      onClick={() =>
                                        handlePayInvoice(invoice.id)
                                      }
                                      className="text-green-600 hover:text-green-800 transition-colors duration-200"
                                      title="Payer la facture"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="py-16 flex flex-col items-center justify-center bg-white">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-12 w-12 text-gray-300 mb-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={1}
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      <p className="text-gray-500 text-lg">
                        Aucune facture trouvée
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "planning" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Planning ({filteredScheduleEntries.length})
                  </h2>
                  <select
                    value={selectedScheduleType}
                    onChange={(e) => setSelectedScheduleType(e.target.value)}
                    className="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="all">Tous les types</option>
                    <option value="mission">Missions</option>
                    <option value="rendezvous">Rendez-vous</option>
                    <option value="formation">Formations</option>
                    <option value="autre">Autres</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {filteredScheduleEntries.map((entry) => (
                    <ScheduleEntryCard
                      key={entry.id}
                      entry={entry}
                      onClick={handleClickScheduleEntry}
                    />
                  ))}
                </div>
              </div>
            )}

            {activeTab === "notes" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Notes ({notes.length})
                  </h2>
                  <button
                    onClick={handleAddNote}
                    className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Ajouter une note
                  </button>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {notes.map((note) => (
                    <NoteCard
                      key={note.id}
                      note={note}
                      onEdit={handleEditNote}
                      onDelete={handleDeleteNote}
                    />
                  ))}
                </div>
              </div>
            )}

            {activeTab === "evenement" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Événements ({filteredEvents.length})
                  </h2>
                  <div className="flex space-x-2">
                    <select
                      value={selectedEventStatus}
                      onChange={(e) => setSelectedEventStatus(e.target.value)}
                      className="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="all">Tous les statuts</option>
                      <option value="upcoming">À venir</option>
                      <option value="completed">Terminés</option>
                      <option value="canceled">Annulés</option>
                    </select>
                    <button
                      onClick={() => console.log("Créer un événement")}
                      className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-1"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Créer un événement
                    </button>
                  </div>
                </div>

                <div className="space-y-3">
                  {filteredEvents.map((event) => (
                    <EventRow
                      key={event.id}
                      event={event}
                      onClick={handleClickEvent}
                    />
                  ))}
                </div>
              </div>
            )}

            {activeTab === "devis" && (
              <div>

                {isCreateDevis && <QuotationModal quotations={quotations} setQuotations={setQuotations} client={selectedClient} isOpen={isCreateDevis} setIsOpen={setIsCreateDevis} />}
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Devis ({quotations.length})
                  </h2>
                  <Button onClick={()=> setIsCreateDevis(true)}>Créer un devis</Button>
                </div>

                {quotations.length === 0 ? (
                  <p className="text-gray-500">Aucun devis trouvé.</p>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {quotations.map((quotation) => {
                      const p = quotation.products?.[0];

                      return (
                        <div
                          key={quotation._id}
                          onClick={() => generatePDF(quotation)}
                          className="cursor-pointer bg-white p-6 shadow-lg rounded-2xl border border-gray-100 hover:shadow-xl transition"
                        >
                          <h3 className="text-xl font-bold text-gray-800 mb-4">
                            📄 Devis n°{quotation.quotationNumber}
                          </h3>

                          {p ? (
                            <div className="space-y-2 text-gray-600 text-sm">
                              <div>
                                <span className="font-medium text-gray-700">
                                  🛠️ Poste :
                                </span>{" "}
                                {p.poste}
                              </div>
                              <div>
                                <span className="font-medium text-gray-700">
                                  📋 Prestation :
                                </span>{" "}
                                {p.type}
                              </div>
                              <div>
                                <span className="font-medium text-gray-700">
                                  💰 Taux :
                                </span>{" "}
                                {p.taux}
                              </div>
                              <div>
                                <span className="font-medium text-gray-700">
                                  📈 Coefficient :
                                </span>{" "}
                                {p.coefficient}
                              </div>
                              <div>
                                <span className="font-medium text-gray-700">
                                  ⏱️ Heures minimales :
                                </span>{" "}
                                {p.minimumHours}
                              </div>
                              <div>
                                <span className="font-medium text-gray-700">
                                  📝 Commentaire :
                                </span>{" "}
                                {p.comment || "—"}
                              </div>
                            </div>
                          ) : (
                            <p className="text-gray-400 italic">
                              Aucun produit dans ce devis.
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {activeTab === "atradius" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Demandes Atradius
                  </h2>
                  <select
                    value={selectedAtradiusStatus}
                    onChange={(e) => setSelectedAtradiusStatus(e.target.value)}
                    className="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="all">Tous les statuts</option>
                    <option value="pending">En attente</option>
                    <option value="approved">Approuvées</option>
                    <option value="rejected">Refusées</option>
                    <option value="review">En révision</option>
                  </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {!cover ? (
                    <p className="text-gray-500">
                      Pas de demande Atradius pour ce client.
                    </p>
                  ) : (
                    <AtradiusCard coverData={cover} />
                  )}
                </div>
              </div>
            )}

            {activeTab === "commentaires" && (
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg font-medium text-gray-800">
                    Commentaires ({comments.length})
                  </h2>
                  <div className="flex space-x-2">
                    <button
                      onClick={handleAddComment}
                      className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-1"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Ajouter un commentaire
                    </button>
                  </div>
                </div>

                <div className="space-y-4">
                  {comments.map((comment) => (
                    <CommentCard
                      key={comment.id}
                      comment={comment}
                      onReply={handleReplyToComment}
                      onEdit={
                        !comment.isInternal ? undefined : handleEditComment
                      }
                      onDelete={
                        !comment.isInternal ? undefined : handleDeleteComment
                      }
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Contact Form Modal */}
      {isContactFormOpen && (
        <ContactFormModal
          isOpen={isContactFormOpen}
          onClose={() => setIsContactFormOpen(false)}
          contact={selectedContact}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
        />
      )}

      {/* File Upload Modal */}
      <FileUploadModal
        isOpen={isFileUploadOpen}
        onClose={() => setIsFileUploadOpen(false)}
        onUpload={handleFileUpload}
      />

      {/* Note Form Modal */}
      <NoteFormModal
        isOpen={isNoteFormOpen}
        onClose={() => setIsNoteFormOpen(false)}
        onSave={handleSaveNote}
        note={selectedNote}
      />

      {/* Comment Form Modal */}
      <CommentFormModal
        isOpen={isCommentFormOpen}
        onClose={() => setIsCommentFormOpen(false)}
        onSave={handleSaveComment}
        comment={selectedComment}
        parentId={replyToCommentId}
      />

      {/* Action Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Actions sur le contrat"
      >
        <div className="space-y-2">
          <button className="flex items-center w-full px-4 py-2 text-left rounded-md text-gray-700 hover:bg-gray-50">
            <span className="mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path
                  fillRule="evenodd"
                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            Voir les détails
          </button>
          <button className="flex items-center w-full px-4 py-2 text-left rounded-md text-gray-700 hover:bg-gray-50">
            <span className="mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </span>
            Modifier
          </button>
          <button className="flex items-center w-full px-4 py-2 text-left rounded-md text-gray-700 hover:bg-gray-50">
            <span className="mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            Imprimer
          </button>
          <button className="flex items-center w-full px-4 py-2 text-left rounded-md text-red-600 hover:bg-red-50">
            <span className="mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            Annuler
          </button>
        </div>
      </Modal>
    </div>
  );
}
